export class ShapeDetails {
    name: string;
    width: number;
    height: number;
    x1: number;
    x2: number;
    x3: number;
    y1: number;
    y2: number;
    y3: number;
    radius: number;
    constructor(line : any) {
		if (line) {
			this.name = line.name;
			this.width = line.width;
			this.height = line.height;
			this.x1 = line.x1;
			this.x2 = line.x2;
			this.x3 = line.x3;
			this.y1 = line.y1;
			this.y2 = line.y2;
			this.y3 = line.y3;
			this.radius = line.radius;
		}
	}
}